import type { IComponentController, IScope } from "angular";
import { forEach as lodashForEach } from "lodash";
import { finalize } from "rxjs/operators";

import type { ICoverageCalculationsService } from "App/Modules/Gui";
import type { IMap, IResponseWithLoading, ISiteEquipmentWithCoverages } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class MapComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository", "mmCoverageCalculationsService"];

    public caption: string;

    public icon: string;

    public map: IResponseWithLoading<IMap>;

    public siteEquipment: IResponseWithLoading<ISiteEquipmentWithCoverages[]>;

    public siteId: string;

    public subCaption: string;

    constructor(
        private readonly $scope: IScope,
        private readonly sitesRepository: ISitesRepository,
        private readonly coverageCalculationsService: ICoverageCalculationsService,
    ) {}

    public $onInit() {
        this.caption = "Entities.Site.Plan";
        this.icon = "globe-americas";

        extendWithLoadingAndFail(this.sitesRepository.getMap(this.siteId)).subscribe((mapResponse) => {
            this.map = mapResponse;
            if (this.map.isLoading) {
                return;
            }

            if (!this.map.data) {
                this.subCaption = "Gui.Manage.NoMapAvailable";
                return;
            }

            this.coverageCalculationsService.polygonToNormalized(this.map.data.scaleCoordinates, this.map.data.image);

            extendWithLoadingAndFail(this.sitesRepository.getSiteEquipmentsWithCoveragesForSite(this.siteId))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe((siteEquipmentResponse) => {
                    this.siteEquipment = siteEquipmentResponse;
                    if (!siteEquipmentResponse.data) {
                        return;
                    }

                    const siteEquipment = siteEquipmentResponse.data;
                    lodashForEach(siteEquipment, (se) => {
                        this.coverageCalculationsService.toAbsolute(se.positionOnMap, this.map.data.image);
                        lodashForEach(se.viewCoverages, (vc) => {
                            this.coverageCalculationsService.polygonToAbsolute(
                                vc.mapCoveragePolygon,
                                this.map.data.image,
                            );
                            // Camera coverage polygon is in normalized coordinats also in the front-end
                        });
                    });

                    this.caption = undefined;
                    this.icon = undefined;
                });
        });
    }
}
